// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"ur-z","breadcrumbForward":"vr-z","breadcrumbBack":"wr-z","selected":"xr-z"};